<template lang="pug">
  .moderation
    v-menu.moderation_menu(v-if="devMode", bottom, left)
      template(v-slot:activator="{ on }")
        v-icon.moderation_activator(
          v-on="on",
          :style="{ top, bottom, right, left }",
          :class="{light, centered: mainCover}") mdi-dots-vertical
      v-list
        v-list-item(
          v-for="(action, index) in actions[this.type]",
          :key="'action_'+index",
          :class="action.class ? action.class : ''",
          @click="() => action.method()")
          div {{ action.text }}
    template
      slot
</template>

<script>
export default {
  props: {
    light: { type: Boolean, default: false },
    type: {
      type: String,
      required: true,
      validator: value => [
        'campaign',
        'user',
        'userProfile',
        'userMain',
        'service',
        'serviceImage',
        'review',
        'overviewItem',
        'chat',
        'award'
      ].indexOf(value) !== -1
    },
    campaignStatus: Number,
    instanceId: Number,
    featureId: Number,
    mainCover: Boolean,
    editor_cover: Boolean,
    top: String,
    right: String,
    left: String,
    bottom: String,
    isWide: Boolean
  },
  data() {
    return {
      showMenu: false,
      actions: {
        campaign: [
          {
            order: 1,
            text: 'Issue a warning',
            method: this.createWarning
          },
          {
            order: 2,
            text: this.campaignStatus !== 6 ? 'Ban campaign' : 'Unban campaign',
            method: this.campaignStatus !== 6 ? this.banCampaign : this.unbanCampaign,
            class: this.campaignStatus !== 6 ? 'warn' : 'highlight'
          },
          {
            order: 3,
            text: this.featureId ? 'Do not display on the main page' : 'Display on the main page',
            method: this.featureId ? this.deleteFeatured : this.setFeatured
          }
        ],
        award: [
          {
            order: 1,
            text: 'Cancel the award',
            method: this.cancelAward,
            class: 'warn'
          }
        ],
        user: [
          {
            order: 1,
            text: 'Issue a warning to the user',
            method: this.createWarning
          },
          {
            order: 2,
            text: 'Ban user',
            method: this.banUser,
            class: 'warn'
          }
        ],
        userMain: [
          {
            order: 1,
            text: 'Issue a warning to the user',
            method: this.createWarning
          },
          {
            order: 2,
            text: 'Ban user',
            method: this.banUser,
            class: 'warn'
          },
          {
            order: 3,
            text: 'Remove from main page',
            method: this.createWarning
          }
        ],
        userProfile: [
          {
            order: 1,
            text: 'Issue a warning to the user',
            method: this.createWarning
          },
          {
            order: 2,
            text: 'Ban user',
            method: this.banUser,
            class: 'warn'
          },
          {
            order: 3,
            text: 'Give a reward',
            method: this.rewardUser
          }
        ],
        chat: [
          {
            order: 1,
            text: 'Issue a warning to the user',
            method: this.createWarning
          },
          {
            order: 2,
            text: 'Ban user',
            method: this.banUser,
            class: 'warn'
          },
          {
            order: 3,
            text: 'Ban message',
            method: this.banUser,
            class: 'warn'
          },
          {
            order: 4,
            text: 'Mute user',
            method: this.banUser,
            class: 'warn'
          },
          {
            order: 5,
            text: 'Remove user from chat',
            method: this.banUser
          }
        ],
        service: [
          {
            order: 1,
            text: 'Issue a warning',
            method: this.createWarning
          },
          {
            order: 2,
            text: 'Ban service',
            method: this.banService,
            class: 'warn'
          },
          {
            order: 3,
            text: 'Display on the main page',
            method: this.createWarning
          }
        ],
        serviceImage: [
          {
            order: 1,
            text: 'Issue a warning',
            method: this.createWarning
          },
          {
            order: 2,
            text: 'Ban image',
            method: this.banService,
            class: 'warn'
          }
        ],
        review: [
          {
            order: 1,
            text: 'Issue a warning to the user',
            method: this.createWarning
          },
          {
            order: 2,
            text: 'Ban review',
            method: this.banReview,
            class: 'warn'
          },
          {
            order: 3,
            text: 'Ban user',
            method: this.banUser,
            class: 'warn'
          },
          {
            order: 4,
            text: 'Reduce impact on rating',
            method: this.reduceImpact
          }
        ],
        overviewItem: [
          {
            order: 1,
            text: 'Issue a warning',
            method: this.createWarning
          },
          {
            order: 2,
            text: 'Ban overview item',
            method: this.banOverview,
            class: 'warn'
          }
        ]
      }
    };
  },
  methods: {
    createWarning() {
      console.log('Issued a warning for', this.type, this.instanceId);
    },
    banCampaign() {
      const data = {
        id: this.instanceId,
        status: { id: 6 }
      };
      this.$store.dispatch('user/updateCampaign', data)
        .then(() => console.log('Banned', this.type, this.instanceId));
    },
    unbanCampaign() {
      const data = {
        id: this.instanceId,
        status: { id: 3 }
      };

      this.$store.dispatch('user/updateCampaign', data)
        .then(() => console.log('Banned', this.type, this.instanceId));
    },
    deleteFeatured() {
      if (!this.featuredId) return;

      const data = {
        campaignId: this.instanceId,
        featuredId: this.featureId
      };

      this.$store.dispatch('user/deleteFeatured', data);
    },
    setFeatured() {
      this.$store.dispatch('user/setFeatured', this.instanceId);
    },
    banUser() {
      console.log('Banned', this.type, this.instanceId);
    },
    banReview() {
      console.log('Banned', this.type, this.instanceId);
    },
    banService() {
      console.log('Banned', this.type, this.instanceId);
    },
    banOverview() {
      console.log('Banned', this.type, this.instanceId);
    },
    reduceImpact() {
      console.log('Reduced impact of', this.type, this.instanceId);
    },
    rewardUser() {
      console.log('Rewarded', this.type, this.instanceId);
    },
    cancelAward() {
      console.log('Canceled award', this.instanceId);
    }
  },
  computed: {
    devMode() { return this.$store.state.develop.active; }
  }
};
</script>

<style scoped lang="scss">
  @import '../assets/scss/variables';

  .moderation {
    position: relative;
    display: flex;

    &_menu { z-index: 500; }

    &:hover,
    .v-menu__activator--active {
      .moderation_activator { opacity: 1 !important; }
    }

    &.main_cover {
      .moderation_activator {
        right: 50%;
        top: 25px;
        @media (max-width: 870px) {
          right: 7%;
          top: 51%;
        }
      }
    }

    &_activator {
      position: absolute;
      padding: 5px;
      color: $light-theme-primary-text;
      opacity: 0;
      transition: opacity .3s $easing;

      &.light { color: $white; }
    }
  }

  .v-list {
    font-weight: 600 !important;

    ::v-deep .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
      color: $blue !important;
      &.warn { color: $error-color !important; }
      &.highlight { color: $sub-black !important; }
    }
  }
</style>
